import { connect } from "react-redux";
import RmLog from "./rmLog";
import { bindActionCreators } from "redux";
import {
  getRMTicketLog
} from "services/redux/installation/siteLog/action";

const mapStateToProps = (state) => ({
  rmTicketLog: state.siteLogReducer.rmTicketLog,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getRMTicketLog
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RmLog);
